import { Box, Typography } from "@mui/material";
import type { Signature as SignatureType } from "@ssf/sign-worker";

import { PreviewSupabase } from "./index.js";

export const Signature = ({
  signature: { email, meta },
}: {
  signature: SignatureType;
}) => {
  return (
    <Typography
      variant="body2"
      component="table"
      sx={{ width: "100%", tableLayout: "fixed", p: 2 }}
    >
      <tbody>
        {Object.entries({ ...(email && { email }), ...meta })
          .filter(
            (entry): entry is [string, string] =>
              // These are legacy metadata fields, which might still be present in old signatures
              !["nameInFile", "hasSigned", "totalNames"].includes(entry[0]) &&
              typeof entry[1] !== "object", // This excludes the biometric data, which is stored as a JSON object in the `meta` field
          )
          .map(([key, value]) =>
            key === "fileUrl" ? (
              <tr key={key}>
                <Box component="td" colSpan={2}>
                  <PreviewSupabase fileUrl={value} />
                </Box>
              </tr>
            ) : (
              <tr key={key}>
                <Box component="td" sx={{ verticalAlign: "top", width: 144 }}>
                  {key}
                </Box>
                <Box
                  component="td"
                  sx={{
                    width: "100%",
                    overflowWrap: "break-word",
                  }}
                >
                  {value}
                </Box>
              </tr>
            ),
          )}
      </tbody>
    </Typography>
  );
};
